"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var maxBy_1 = __importDefault(require("lodash/maxBy"));
var memoize_1 = __importDefault(require("lodash/memoize"));
var react_1 = __importStar(require("react"));
var UnknownRenderer_1 = require("./UnknownRenderer");
var core_1 = require("@jsonforms/core");
var JsonFormsContext_1 = require("./JsonFormsContext");
var object_hash_1 = __importDefault(require("object-hash"));
var hasRefs = memoize_1.default(function (schema) {
    if (schema !== undefined) {
        return Object.keys(core_1.findRefs(schema)).length > 0;
    }
    return false;
}, function (schema) { return (schema ? object_hash_1.default(schema) : false); });
var ResolvedJsonFormsDispatchRenderer = /** @class */ (function (_super) {
    __extends(ResolvedJsonFormsDispatchRenderer, _super);
    function ResolvedJsonFormsDispatchRenderer(props) {
        var _this = _super.call(this, props) || this;
        _this.mounted = false;
        _this.resolveAndUpdateSchema = function (props) {
            props.refResolver(props.schema).then(function (resolvedSchema) {
                _this.setState({
                    resolving: false,
                    resolvedSchema: resolvedSchema
                });
            });
        };
        _this.state = {
            id: core_1.isControl(props.uischema)
                ? core_1.createId(props.uischema.scope)
                : undefined,
            schema: props.schema,
            resolvedSchema: props.schema,
            resolving: false
        };
        return _this;
    }
    ResolvedJsonFormsDispatchRenderer.getDerivedStateFromProps = function (nextProps, prevState) {
        if (!isEqual_1.default(prevState.schema, nextProps.schema)) {
            var schemaHasRefs = hasRefs(nextProps.schema);
            var newState = {
                id: prevState.id,
                resolvedSchema: schemaHasRefs ? undefined : nextProps.schema,
                schema: nextProps.schema,
                resolving: schemaHasRefs
            };
            return newState;
        }
        return null;
    };
    ResolvedJsonFormsDispatchRenderer.prototype.componentDidMount = function () {
        if (this.state.resolving) {
            this.resolveAndUpdateSchema(this.props);
        }
    };
    ResolvedJsonFormsDispatchRenderer.prototype.componentDidUpdate = function () {
        if (this.state.resolving) {
            this.resolveAndUpdateSchema(this.props);
        }
    };
    ResolvedJsonFormsDispatchRenderer.prototype.componentWillUnmount = function () {
        this.mounted = false;
        if (core_1.isControl(this.props.uischema)) {
            core_1.removeId(this.state.id);
        }
    };
    ResolvedJsonFormsDispatchRenderer.prototype.render = function () {
        var _a = this.props, uischema = _a.uischema, path = _a.path, enabled = _a.enabled, renderers = _a.renderers;
        var resolving = this.state.resolving;
        var _schema = this.state.resolvedSchema;
        if (resolving) {
            return react_1.default.createElement("div", null, "Loading...");
        }
        var renderer = maxBy_1.default(renderers, function (r) { return r.tester(uischema, _schema); });
        if (renderer === undefined || renderer.tester(uischema, _schema) === -1) {
            return react_1.default.createElement(UnknownRenderer_1.UnknownRenderer, { type: 'renderer' });
        }
        else {
            var Render = renderer.renderer;
            return (react_1.default.createElement(Render, { uischema: uischema, schema: _schema, path: path, enabled: enabled, renderers: renderers, id: this.state.id }));
        }
    };
    return ResolvedJsonFormsDispatchRenderer;
}(react_1.default.Component));
exports.ResolvedJsonFormsDispatchRenderer = ResolvedJsonFormsDispatchRenderer;
var JsonFormsDispatchRenderer = /** @class */ (function (_super) {
    __extends(JsonFormsDispatchRenderer, _super);
    function JsonFormsDispatchRenderer(props) {
        var _this = _super.call(this, props) || this;
        var isResolved = !hasRefs(props.schema);
        _this.state = __assign({}, _this.state, { resolvedSchema: isResolved ? props.schema : undefined, resolving: !isResolved });
        return _this;
    }
    return JsonFormsDispatchRenderer;
}(ResolvedJsonFormsDispatchRenderer));
exports.JsonFormsDispatchRenderer = JsonFormsDispatchRenderer;
exports.JsonFormsDispatch = react_1.default.memo(function (props) {
    var ctx = JsonFormsContext_1.useJsonForms();
    var refResolver = JsonFormsContext_1.ctxToJsonFormsDispatchProps(ctx, props).refResolver;
    var _a = ctx.core, data = _a.data, errors = _a.errors;
    react_1.useLayoutEffect(function () {
        props.onChange && props.onChange({ data: data, errors: errors });
    }, [data, errors]);
    return (react_1.default.createElement(JsonFormsDispatchRenderer, { schema: props.schema || ctx.core.schema, uischema: props.uischema || ctx.core.uischema, path: props.path || '', enabled: props.enabled, rootSchema: ctx.core.schema, renderers: ctx.renderers, refResolver: refResolver }));
});
exports.JsonForms = function (props) {
    var ajv = props.ajv, data = props.data, schema = props.schema, uischema = props.uischema, renderers = props.renderers, cells = props.cells, refParserOptions = props.refParserOptions, onChange = props.onChange;
    var schemaToUse = schema !== undefined ? schema : core_1.Generate.jsonSchema(data);
    var uischemaToUse = typeof uischema === 'object' ? uischema : core_1.Generate.uiSchema(schemaToUse);
    return (react_1.default.createElement(JsonFormsContext_1.JsonFormsStateProvider, { initState: {
            core: {
                ajv: ajv,
                data: data,
                refParserOptions: refParserOptions,
                schema: schemaToUse,
                uischema: uischemaToUse
            },
            renderers: renderers,
            cells: cells
        } },
        react_1.default.createElement(exports.JsonFormsDispatch, { onChange: onChange })));
};
//# sourceMappingURL=JsonForms.js.map